export default __webpack_public_path__ + "static/media/def.5c05a1c8.png";